import React from 'react'
import { useDispatch } from 'react-redux'
import { getAllApplications } from '../../../../../../redux/actions/application'
import CustomButton from '../../../../../common/CustomButton'
import './style.sass'

const AppListErrorState = () => {
  const dispatch = useDispatch()

  return (
    <div className="app-list-error-state-container">
      <div className="wrapper">
        <div className="card-container">
          <h5>Oh no! Couldn't load the applications :(</h5>
          <p>
            Something went wrong while retrieving applications.
            You can refresh page or if you already refreshed the page please wait few minutes and refresh page again.
          </p>
          <CustomButton
            onClick={() => dispatch(getAllApplications())}
            buttonText="Try refreshing"
            className="btn btn-fill"
          />
        </div>
      </div>
    </div>
  )
}

export default AppListErrorState
